export const FETCH_CUSTOM_LESSONS = "FETCH_CUSTOM_LESSONS";
export const EDIT_CUSTOM_LESSONS_INFO = "EDIT_CUSTOM_LESSONS_INFO";
export const INSERT_CUSTOM_LESSONS_INFO = "INSERT_CUSTOM_LESSONS_INFO";
export const DELETE_CUSTOM_LESSONS_INFO = "DELETE_CUSTOM_LESSONS_INFO";
